<template lang='pug'>
.news-container
    .base-title {{ title }}
    .panel-wrapper
        .panel(v-for='item in list', :key="item.id" @click='jumpTo(item)')
            img(v-src='item.detail.banner')
            .title {{ item.detail.name }}
</template>

<script>
import anime, { stagger } from 'animejs'
import { getDataHierarchy, getDataRows, getPathNames } from '@custouch/proxy-use'
export default {
    // props: ['title'],
    data() {
        return {
            list: [],
            title: ''
        }
    },
    methods: {
        jumpTo(item) {
            if (item.detail.link) {
                window.location.href = item.detail.link
                this.$message.loading({
                    message: '跳转中...',
                    forbidClick: true,
                    duration: 3000
                })
            } else {
                // this.$router.push({ name: 'newsFrame', params: { name: item.detail.name } })
                const { DATA } = window.env
                const { module } = DATA
                this.$router.push({
                    name: 'newsFrame',
                    params: {
                        rId: item.id
                    },
                    query: {
                        hId: module.interaction.hierarchies.news
                    }
                })
            }
        }
    },
    async created() {
        // this.list = await this.$store.dispatch('getJson', window.env.VUE_APP_DATA_MARKET_NEWS)
        const { DATA } = window.env
        const { module,template } = DATA
        const [ret,{data},title] = await Promise.all([
            getDataHierarchy({dataHierarchyId: module.interaction.hierarchies.news }),
            getDataRows({
                dataHierarchyId: module.interaction.hierarchies.news,
                dataTemplateId: template.news,
                index: 1,
                size: 20
            }),
            getPathNames(module.interaction.hierarchies.news)
        ])
        this.title = ret.name
        this.list = data
        this.$root.$emit('pageview',{
            title
        })
        this.$nextTick(() => {
            const t1 = anime.timeline({
                duration: 500,
                delay: anime.stagger(150),
                easing: 'easeInSine'
            })
            t1.add({
                targets: '.panel > img',
                opacity: [0, 1],
                translateX: ['-100%', 0],
            }).add({
                targets: '.panel > .title',
                opacity: [0, 1],
                translateX: ['100%', 0],
            }, 0)
        })
    }
}
</script>

<style scoped lang='less'>
.news-container {
    .panel-wrapper {
        padding: 0 1rem;
    }
    .panel {
        height: 4.5rem;
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 1.2rem;
        > img {
            opacity: 0;
            width: 6.5rem;
            height: 100%;
            object-fit: cover;
        }
        .title {
            opacity: 0;
            background: #f9f9f9;
            height: 100%;
            display: flex;
            align-items: center;
            flex: 1;
            padding-left: 1.2rem;
        }
    }
}
</style>